// extracted by mini-css-extract-plugin
module.exports = {"title":"License_title__CR4f1","name":"License_name__3tHSw","invoiceField":"License_invoiceField__2wtKM"};